import DashUserLoadStatusFormProperties from './DashUserLoadStatusFormProperties'
import DashUserLoadStatusApiUrls from 'src/apiUrls/ForwardHubApiUrls'
import { components } from 'cng-web-lib'
import React from 'react'

const {
  form: { CngViewForm }
} = components

function DashUserLoadStatusViewForm({
  showNotification,
  id,
  onFetchPreSuccess = () => {
    // this is intentional
  }
}) {
  return (
    <CngViewForm
      fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
      showNotification={showNotification}
      bodySection={
        <DashUserLoadStatusFormProperties.Fields
          disabled={true}
          showNotification={showNotification}
        />
      }
      formikProps={DashUserLoadStatusFormProperties.formikProps}
      toClientDataFormat={DashUserLoadStatusFormProperties.toClientDataFormat}
      toServerDataFormat={DashUserLoadStatusFormProperties.toServerDataFormat}
      fetch={{
        id: id,
        url: DashUserLoadStatusApiUrls.GET,
        onPreSuccess: onFetchPreSuccess
      }}
    />
  )
}

export default DashUserLoadStatusViewForm
